<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Aqui você pode conferir todas as startups cadastradas até o
              momento. Toda nova conta criada aparecerá automaticamente na
              listagem abaixo.
            </p>
          </div>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--7">
      <div class="row">
        <div class="col-lg-12 mb-4">
          <div class="float-right">
            <base-button
              class="mb-3"
              type="white"
              title="'Gerenciar parcerias'"
              @click="$router.push('/admin/beneficios-aceleradas')"
              ><i class="fas fa-handshake text-success mr-2"></i> Benefícios
              aceleradas</base-button
            >
          </div>
        </div>
        <div class="col">
          <div v-if="empty">
            <div class="row">
              <div class="col-12 text-center">
                <badge type="info" class="bg-white">
                  Não existem startups cadastradas até o momento
                </badge>
              </div>
            </div>
          </div>
          <div v-else class="card-deck vld-parent" ref="startups_list">
            <div
              class="col-lg-4 col-md-6 mb-5 d-flex align-items-stretch"
              v-for="startup in startups"
              :key="startup.user_id"
            >
              <div class="card text-center flex-grow-1">
                <div class="card-profile-image">
                  <img
                    :src="startup.logo.url"
                    class="card-image my-3"
                    alt="..."
                  />
                </div>
                <div class="card-body mt-8 pt-0 pb-1">
                  <h2 class="card-title text-orange mb-1">
                    {{ startup.name }}
                  </h2>
                  <div>
                    <div class="h5 font-weight-300 mb-1">
                      <i class="ni ni-pin-3 mr-2"></i
                      >{{ startup.city || "..." }}, {{ startup.state || "..." }}
                    </div>
                    <div>
                      <div class="h5 font-weight-300 mb-1">
                        <i class="fas fa-envelope mr-2"></i
                        >{{ startup.user.email }}
                      </div>
                    </div>
                    <div class="h5 mt-2">
                      <badge type="info">
                        {{ startup.sector }}
                      </badge>
                    </div>
                  </div>
                </div>
                <div class="card-footer text-center">
                  <router-link
                    :to="'/admin/startups/' + startup.user_id + '/editar'"
                    class="btn btn-white py-1 px-2"
                    title="Editar startup"
                    ><i class="fas fa-edit text-info"></i
                  ></router-link>
                  <span
                    @click="handleOpenModalConfirmation(startup)"
                    class="btn btn-white py-1 px-2 cursor-pointer"
                    title="Deletar startup"
                  >
                    <i class="fas fa-trash text-red"></i>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-12 text-muted text-right">
              {{ startups.length }} startups cadastradas ao total
            </div>
          </div>
        </div>
      </div>
      <hr :class="[empty ? 'mt-6' : 'mt-3', 'mb-1']" />
      <div class="row">
        <div class="col text-right">
          <base-button
            type="link"
            :custom="true"
            @click="$router.push('/admin/startups-tabela')"
            >Visualizar como tabela</base-button
          >
        </div>
      </div>
    </div>
    <modal
      :show.sync="modals.modalConfirmation"
      gradient="dark"
      modal-classes="modal-danger modal-dialog-centered"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atenção!
      </h6>
      <div class="vld-parent" ref="modal_confirmation_delete">
        <div class="py-3 text-center">
          <i class="fa fa-trash fa-3x"></i>
          <h4 class="heading mt-4">
            Você realmente deseja excluir a startup
            <span class="text-warning">{{ modals.startupName }}</span
            >?
          </h4>
          <p class="mt-3 mb-0">
            Todas as informações relacionadas a startup
            <span class="text-warning">{{ modals.startupName }}</span> ({{
              modals.startupEmail
            }}) serão perdidas.
          </p>
        </div>
      </div>
      <template slot="footer">
        <base-button
          type="link"
          text-color="white"
          class="ml-auto"
          @click="handleCloseModalConfirmation"
        >
          Voltar
        </base-button>
        <base-button
          type="white text-danger"
          @click="handleSubmitRemoveStartup"
        >
          Confirmar exclusão
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import api from "@/services/api";

export default {
  name: "startups_list",
  data() {
    return {
      startups: [],
      empty: false,
      modals: {
        modalConfirmation: false,
        startupName: "",
        startupEmail: "",
        startupId: null,
      },
    };
  },
  async mounted() {
    const loader = this.$loading.show({
      container: this.$refs.startups_list,
      width: 150,
      height: 150,
      opacity: 0,
    });
    try {
      const { data } = await api.get("/adm/startups");
      const defaultLogoPath = "/img/pages/default_logo.png";
      data.forEach((startup) => {
        if (!startup.logo) startup.logo = { url: defaultLogoPath };
      });
      if (data.length) this.startups = data;
      else this.empty = true;
      loader.hide();
    } catch (e) {
      this.$toasted.error("Ocorreu um erro ao recuperar as startups");
    }
  },
  methods: {
    handleOpenModalConfirmation(startup) {
      this.modals.startupId = startup.user.id;
      this.modals.startupName = startup.name;
      this.modals.startupEmail = startup.user.email;
      this.modals.modalConfirmation = true;
    },
    handleCloseModalConfirmation() {
      this.modals.modalConfirmation = false;
      this.modals.startupId = null;
      this.modals.startupName = "";
      this.modals.startupEmail = "";
    },
    async handleSubmitRemoveStartup() {
      const loader = this.$loading.show({
        container: this.$refs.modal_confirmation_delete,
        width: 160,
        height: 160,
        opacity: 0,
      });
      try {
        await api.delete(`/adm/startups/${this.modals.startupId}`);
        this.$toasted.show("Startup removida com sucesso");
        this.$router.go();
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao remover a startup");
      } finally {
        loader.hide();
      }
    },
  },
};
</script>
<style scoped>
.card-image {
  width: 145px;
  height: 145px;
  border-radius: 10%;
  margin: auto;
}
.table-container {
  min-height: 150px;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
